/* Stitchi Studio · ss-site.js (fase D)
   Kop en voet op elke pagina, 1-op-1 het gedrag uit de preview (site.js):
   - aankondigingsbalk: deadlinetekst opnieuw berekend in de browser (SS.DEADLINES uit ss-core.js; de pagina kan uit de cache komen)
   - mega-menu: Esc sluit, focus terug naar het menu-item, dicht tot focus/muis het item verlaat (.mega-uit)
   - voetkolommen dicht op telefoons
   - zoeklaag: "Uitgelicht" bij openen, voorspellend zoeken via /search/suggest (Section Rendering: sections/ss-zoek-suggest.liquid)
     plus de vaste paginalijst (preview SS.PAGINAS, met synoniemen) uit #zoek-paginas
   - nieuwsbrief: eigen controle van het e-mailadres (zoals de preview), verzenden via {% form 'customer' %}
   - welkomstpop-up (sections/ss-welkom.liquid): na 5 s of 20% scrollen of exit-intent, 14 dagen niet opnieuw; wacht op cookiebanner en open lagen.
   Vereist ss-core.js (SS.open/close/trap/toast/store/DEADLINES). */
(function () {
  'use strict';
  var SS = window.SS = window.SS || {};
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var store = SS.store || { get: function (k, d) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } }, set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} } };
  var MAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  /* teksten uit locales (sections/ss-header.liquid #ss-teksten-site); terugval = Nederlands */
  var TX = { geefBon: 'Geef een cadeaubon', gratisVerzending: 'gratis verzending', paginas: 'Pagina’s', producten: 'Producten', resultaat: 'resultaat', resultaten: 'resultaten',
    niets: 'Niets gevonden voor “{q}”. Probeer ‘hond’, ‘tulpen’, ‘Amsterdam’ of ‘cadeaubon’.', mailFout: 'Vul een geldig e-mailadres in' };
  try { var tx = JSON.parse((document.getElementById('ss-teksten-site') || {}).textContent || '{}'); for (var k in tx) if (tx[k]) TX[k] = tx[k]; } catch (e) {}

  /* ---------- aankondiging ---------- */
  function aankondiging() {
    var ak = $('[data-ss-aankondiging]'); if (!ak) return;
    var D = SS.DEADLINES, span = ak.firstElementChild && ak.firstElementChild.tagName === 'SPAN' ? ak.firstElementChild : null;
    if (D && D.actief && D.tekst) {
      var bon = ak.getAttribute('data-bon');
      var html = '<span>🎁 <b><span class="ak-vol">' + esc(D.tekst) + '</span><span class="ak-kort">' + esc(D.kort) + '</span></b>' +
        (D.naDeadline ? (bon ? ' · <a href="' + esc(bon) + '">' + esc(TX.geefBon) + '</a>' : '') : '<span class="ak-lang"> · ' + esc(TX.gratisVerzending) + '</span>') + '</span>';
      if (span) span.outerHTML = html; else ak.insertAdjacentHTML('afterbegin', html);
      ak.classList.remove('ak-salie'); ak.classList.add('ak-donker');
    } else {
      var tpl = $('template[data-ak-standaard]', ak);
      if (tpl && span && /🎁/.test(span.textContent)) {
        span.outerHTML = tpl.innerHTML;
        var kl = ak.getAttribute('data-kleur'); if (kl) { ak.classList.remove('ak-donker', 'ak-salie'); ak.classList.add('ak-' + kl); }
      }
    }
  }

  /* ---------- mega-menu: Esc (preview "gaten 20-10") ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || $('.lade.open, .zoek-paneel.open, #welkom')) return;
    var li = $$('.hoofdnav li').filter(function (x) { return x.querySelector('.mega') && (x.contains(document.activeElement) || x.matches(':hover')); })[0];
    if (!li || li.classList.contains('mega-uit')) return;
    li.classList.add('mega-uit');
    if (li.contains(document.activeElement)) { var a = li.querySelector('a'); if (a) a.focus(); }
  });
  document.addEventListener('focusout', function (e) { var li = e.target.closest && e.target.closest('.hoofdnav li.mega-uit'); if (li && !li.contains(e.relatedTarget)) li.classList.remove('mega-uit'); });
  document.addEventListener('mouseover', function (e) { var li = e.target.closest && e.target.closest('.hoofdnav li.mega-uit'); if (li && !li.contains(e.relatedTarget)) li.classList.remove('mega-uit'); });

  /* ---------- zoeklaag ---------- */
  var PAGINAS = [];
  try { PAGINAS = JSON.parse(($('#zoek-paginas') || {}).textContent || '[]') || []; } catch (e) { PAGINAS = []; }
  SS.zoekPaginas = function (q) {
    q = String(q || '').toLowerCase().trim(); if (q.length < 2) return [];
    var w = q.split(/\s+/).filter(function (x) { return x.length > 1; }); if (!w.length) return [];
    return PAGINAS.filter(function (p) {
      var woorden = (p.t + ' ' + p.w).toLowerCase().replace(/[&]/g, ' ').split(/\s+/);
      return w.every(function (x) { return woorden.some(function (y) { return y.indexOf(x) === 0 || (x.length > 4 && y.indexOf(x) > -1); }); });
    });
  };
  SS.paginaHitsHTML = function (lijst, klas) {
    return lijst.map(function (p) { return '<a class="' + (klas || 'zoek-pagina') + '" href="' + esc(p.u) + '"><span><b>' + esc(p.t) + '</b><small>' + esc(p.o) + '</small></span><span aria-hidden="true">→</span></a>'; }).join('');
  };
  function zoeken() {
    var paneel = $('#zoek'), inp = $('#zoekq'), res = $('#zoekres'); if (!paneel || !inp || !res) return;
    var url = paneel.getAttribute('data-suggest') || '/search/suggest', tpl = $('#zoek-uitgelicht'), ctl = null, t = null, laatste = '';
    function uitgelicht() { if (tpl) res.innerHTML = tpl.innerHTML; }
    function zoek() {
      var q = inp.value.trim();
      if (q.length < 2) { laatste = ''; if (ctl) ctl.abort(); uitgelicht(); return; }
      if (q === laatste) return; laatste = q;
      if (ctl) ctl.abort(); ctl = window.AbortController ? new AbortController() : null;
      var u = url + '?q=' + encodeURIComponent(q) + '&resources[type]=product,page,article&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=last&section_id=ss-zoek-suggest';
      fetch(u, ctl ? { signal: ctl.signal } : {}).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        if (q !== inp.value.trim()) return;
        var d = document.createElement('div'); d.innerHTML = html;
        var box = $('[data-suggest-res]', d), n = box ? +box.getAttribute('data-producten') || 0 : 0;
        var prod = box ? $('[data-suggest-producten]', box) : null, pgShop = box ? $$('[data-suggest-paginas] a', box) : [];
        var eigen = SS.zoekPaginas(q), gezien = {};
        var pgHtml = eigen.map(function (p) { gezien[p.u] = 1; return SS.paginaHitsHTML([p]); }).join('') +
          pgShop.filter(function (a) { var h = a.getAttribute('href'); if (gezien[h]) return false; gezien[h] = 1; return true; }).map(function (a) { return a.outerHTML; }).join('');
        var ph = pgHtml ? '<p class="zoek-titel">' + esc(TX.paginas) + '</p><div class="zoek-paginas">' + pgHtml + '</div>' : '';
        if (!n) res.innerHTML = ph + (pgHtml ? '' : '<p class="zoek-titel">' + esc(TX.niets).replace('{q}', esc(q)) + '</p>');
        else {
          /* herstel 2: producten eerst; daaronder hooguit 3 pagina's/artikelen */
          var kort = pgHtml ? (function () { var x = document.createElement('div'); x.innerHTML = pgHtml; return Array.prototype.slice.call(x.children, 0, 3).map(function (a) { return a.outerHTML; }).join(''); })() : '';
          res.innerHTML = '<p class="zoek-titel">' + (pgHtml ? esc(TX.producten) + ' · ' : '') + n + ' ' + esc(n === 1 ? TX.resultaat : TX.resultaten) + '</p>' + prod.innerHTML +
            (kort ? '<p class="zoek-titel">' + esc(TX.paginasArtikelen || TX.paginas) + '</p><div class="zoek-paginas">' + kort + '</div>' : '');
        }
      }).catch(function () {});
    }
    inp.addEventListener('input', function () { clearTimeout(t); t = setTimeout(zoek, 180); });
    document.addEventListener('ss:open', function (e) { if (e.detail && e.detail.id === 'zoek') { if (inp.value.trim().length < 2) uitgelicht(); else zoek(); } });
  }

  /* ---------- nieuwsbrief in de voet ---------- */
  function nieuwsbrief() {
    var f = $('#nb-form'); if (!f) return;
    f.noValidate = true;
    f.addEventListener('submit', function (e) {
      var i = f.querySelector('input[type=email]'); if (!i) return;
      if (!MAIL.test(i.value.trim())) { e.preventDefault(); i.setAttribute('aria-invalid', 'true'); i.focus(); if (SS.toast) SS.toast(TX.mailFout); return; }
      store.set('ss_nieuwsbrief', 1);
    });
    var ok = $('[data-nb-ok]', f); if (ok) { store.set('ss_nieuwsbrief', 1); try { ok.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---------- welkomstpop-up (29-10: werking/aanbod/tags van live, opmaak van dit thema) ---------- */
  var WK = $('[data-ss-welkom]');
  var WK_LAAD = Date.now(), wkConsentGekozen = false;
  document.addEventListener('visitorConsentCollected', function () { wkConsentGekozen = true; });
  function tpl(naam) { var t = WK && $('template[data-wk="' + naam + '"]', WK); return t ? t.innerHTML : ''; }
  function wkGetal(a, d) { var n = parseInt(WK && WK.getAttribute(a), 10); return n > 0 ? n : d; }
  function uitgesloten() {
    var pad = location.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i, '');
    return String(WK.getAttribute('data-uit') || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean).some(function (x) { return pad.indexOf(x) === 0; });
  }
  function zichtbaar(el) {
    if (!el) return false;
    var cs = getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && el.getBoundingClientRect().height > 0;
  }
  /* iets anders open (SS.bezig), de Shopify-cookiebanner in beeld of de chat open? */
  function wkBezetDirect() {
    return !!((SS.bezig && SS.bezig()) || zichtbaar(document.getElementById('shopify-pc__banner')) || zichtbaar(document.getElementById('mpw-box')));
  }
  /* toestemming nog niet gegeven terwijl Shopify een banner verwacht: even wachten tot de banner verschijnt (hij komt pas na het laden) */
  function wkConsentOpen() {
    if (wkConsentGekozen) return false;
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || !cp.shouldShowBanner || !cp.shouldShowBanner()) return false;
      var c = cp.currentVisitorConsent ? cp.currentVisitorConsent() : null;
      var leeg = !c || ['marketing', 'analytics', 'preferences'].every(function (k) { return !c[k]; });
      return leeg && Date.now() - WK_LAAD < 6000;
    } catch (e) { return false; }
  }
  function wkBezet() { return wkBezetDirect() || wkConsentOpen() || document.hidden; }
  SS.welkom = function (forceer) {
    if (!WK) return false;
    if (!forceer) {
      if (uitgesloten() || store.get('ss_nieuwsbrief', '')) return false;
      var t = store.get('ss_welkom_t', 0); if (t && Date.now() - t < wkGetal('data-dagen', 14) * 864e5) return false;
      if (wkBezetDirect()) return 'later';
    }
    if ($('#welkom')) return false;
    store.set('ss_welkom_t', Date.now());
    var d = document.createElement('div'); d.className = 'wk-houder'; d.innerHTML = tpl('basis');
    document.body.appendChild(d);
    var wk = $('#welkom', d), inn = $('.wk-in', wk), vorige = document.activeElement;
    inn.innerHTML = tpl('stap1');
    if (SS.trap) SS.trap(wk);
    function focusWk(el) { setTimeout(function () { if (!document.body.contains(wk)) return; if (el) { try { el.focus({ preventScroll: true }); } catch (e) {} } if (!wk.contains(document.activeElement)) wk.focus({ preventScroll: true }); }, 80); }
    focusWk();
    requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add('wk-open'); }); });
    function sluit() { d.classList.remove('wk-open'); setTimeout(function () { d.remove(); }, 250); if (vorige && vorige.focus && document.contains(vorige)) vorige.focus(); document.removeEventListener('keydown', esc_); }
    function esc_(e) { if (e.key === 'Escape') sluit(); }
    document.addEventListener('keydown', esc_);
    function klaar(alBekend) {
      store.set('ss_nieuwsbrief', 1); store.set('ss_wk_bezig', 0);
      inn.innerHTML = tpl('klaar');
      var al = $('[data-wk-al]', inn); if (al && alBekend) al.hidden = false;
      focusWk($('[data-wk-kopieer]', inn));
    }
    SS.welkomKlaar = klaar;
    function kopieer(btn) {
      var code = WK.getAttribute('data-code') || '', oud = btn.getAttribute('data-oud') || btn.textContent, st = $('[data-wk-status]', inn);
      btn.setAttribute('data-oud', oud);
      function gelukt() {
        btn.textContent = btn.getAttribute('data-klaar') || oud; if (st) st.textContent = btn.textContent;
        setTimeout(function () { btn.textContent = oud; if (st) st.textContent = ''; }, 2400);
      }
      function terugval() {
        var ta = document.createElement('textarea'); ta.value = code; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
        wk.appendChild(ta); ta.select(); try { document.execCommand('copy'); } catch (e) {} ta.remove(); btn.focus(); gelukt();
      }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(gelukt, terugval); else terugval();
    }
    /* antwoord van Shopify lezen als er geen customer_posted=true terugkomt: bestaand adres = gewoon de code tonen (zoals live) */
    var BEKEND = /taken|already|exist|bereits|vergeben|déjà|existe|già|esiste|en uso|in uso|in gebruik|bestaat al|既に|すでに|登録済/i;
    function leesAntwoord(html) {
      var m = /data-wk-shopfout="([^"]*)"/.exec(html), tekst = '';
      if (m) { var x = document.createElement('textarea'); x.innerHTML = m[1]; tekst = x.value; }
      else {
        try {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          $$('template', doc).forEach(function (t) { t.remove(); });
          tekst = $$('.errors, .form__message, .form-error, [role=alert]', doc).map(function (e) { return e.textContent; }).join(' ').trim();
        } catch (e) { tekst = ''; }
      }
      if (!tekst) return 'onbekend';
      if (BEKEND.test(tekst)) return 'bekend';
      if (/email|e-mail/i.test(tekst)) return 'mail';
      return 'onbekend';
    }
    function stap2() {
      inn.innerHTML = tpl('stap2');
      var f = $('form', inn), i = $('#wk-mail', inn), fout = $('#wk-fout', inn);
      if (!f || !i) return;
      f.noValidate = true;
      focusWk(window.innerWidth > 900 ? i : null);
      var veld = i.closest('.veld');
      function toonFout(tekst) {
        if (fout) fout.textContent = tekst || fout.getAttribute('data-mail') || '';
        i.setAttribute('aria-invalid', 'true'); if (veld) veld.classList.add('ongeldig'); i.focus();
      }
      i.addEventListener('input', function () { if (veld && veld.classList.contains('ongeldig') && MAIL.test(i.value.trim())) { veld.classList.remove('ongeldig'); i.removeAttribute('aria-invalid'); } });
      /* Verzenden zonder herladen. Shopify zet hCaptcha op dit formulier: die onderschept de submit en verstuurt na de controle
         zelf. Roept hij form.submit() aan, dan gaat het via fetch (uitkomst leesbaar: gelukt / adres bekend / fout). Gebruikt hij
         de native verzending, dan gaat het naar een verborgen iframe zoals live; Shopify-pagina's mogen niet in een iframe
         (frame-ancestors 'none'), dus dan geldt "geladen = gelukt", net als live. */
      var ifr = document.createElement('iframe');
      ifr.name = 'wk-doel'; ifr.title = ''; ifr.hidden = true; ifr.tabIndex = -1; ifr.setAttribute('aria-hidden', 'true');
      wk.appendChild(ifr); f.target = 'wk-doel';
      var knop = $('button[type=submit]', f), wacht = false, vangnet = null;
      function los() { if (knop) knop.classList.remove('laden'); }
      function uitkomst(a) {
        if (!wacht) return; wacht = false; clearTimeout(vangnet); los();
        if (a === 'gelukt') klaar(false); else if (a === 'bekend') klaar(true); else if (a === 'mail') toonFout(); else toonFout(fout && fout.getAttribute('data-algemeen'));
      }
      ifr.addEventListener('load', function () {
        if (!wacht) return;
        var a = 'gelukt';
        try { var u = ifr.contentWindow.location.href; if (u && u !== 'about:blank' && !/customer_posted=true/.test(u)) a = leesAntwoord(ifr.contentDocument.documentElement.outerHTML); } catch (e) {}
        uitkomst(a === 'onbekend' ? 'gelukt' : a);
      });
      f.submit = function () {
        fetch(f.action, { method: 'POST', body: new URLSearchParams(new FormData(f)), credentials: 'same-origin' }).then(function (r) {
          var u = r.url || '';
          if (/customer_posted=true/.test(u)) { uitkomst('gelukt'); return; }
          if (/\/challenge/.test(u)) { wacht = false; store.set('ss_wk_bezig', 1); f.removeAttribute('target'); HTMLFormElement.prototype.submit.call(f); return; }
          return r.text().then(function (html) { uitkomst(leesAntwoord(html)); });
        }).catch(function () { uitkomst('fout'); });
      };
      f._wkVoor = function (e) {
        if (!MAIL.test(i.value.trim())) { e.preventDefault(); e.stopImmediatePropagation(); toonFout(); return; }
        /* exact live: accepts_marketing = true alleen met het vinkje, anders false (de aanmelding met tags gaat altijd door) */
        var vlag = $('[data-wk-vlag]', f), vink = $('[data-wk-toestemming]', f);
        if (vlag) vlag.value = vink && vink.checked ? 'true' : 'false';
        if (knop) knop.classList.add('laden');
        wacht = true; clearTimeout(vangnet);
        vangnet = setTimeout(function () { los(); }, 15000);   /* bv. captcha weggeklikt: knop weer bruikbaar */
      };
    }
    d.addEventListener('click', function (e) {
      if (e.target.closest('[data-wk-verder]')) { stap2(); return; }
      var k = e.target.closest('[data-wk-kopieer]'); if (k) { kopieer(k); return; }
      if (e.target.closest('[data-wk-sluit]')) sluit();
    });
    return true;
  };
  /* controle vóór verzenden in de capture-fase van window: loopt vóór Shopify's captcha-handler (ongeldig adres = geen captcha, niets verstuurd) */
  window.addEventListener('submit', function (e) { var f = e.target; if (f && f._wkVoor) f._wkVoor(e); }, true);
  /* na een gewone verzending (oude controlepagina; terug van Shopify met ?customer_posted=true): pop-up direct in de eindstand */
  function welkomTerug() {
    if (!WK || !/customer_posted=true/.test(location.search) || !store.get('ss_wk_bezig', 0)) return false;
    SS.welkom(true); if (SS.welkomKlaar) SS.welkomKlaar(false);
    return true;
  }
  function welkomPlannen() {
    if (!WK || welkomTerug()) return;
    if (window.Shopify && window.Shopify.designMode) {
      var toon = function () { if (!$('#welkom')) SS.welkom(true); };
      toon(); document.addEventListener('shopify:section:load', function () { WK = $('[data-ss-welkom]'); toon(); });
      return;
    }
    var gewenst = false, klaar = false, vrij = 0;
    function wil() { gewenst = true; }
    setTimeout(wil, wkGetal('data-sec', 5) * 1000);
    var pct = wkGetal('data-scroll', 20);
    function opScroll() {
      var h = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      if (window.scrollY / h * 100 >= pct) { wil(); removeEventListener('scroll', opScroll); }
    }
    addEventListener('scroll', opScroll, { passive: true });
    if (WK.getAttribute('data-exit') !== '0' && window.matchMedia && matchMedia('(min-width: 990px) and (pointer: fine)').matches) {
      document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) wil(); });
    }
    /* tonen zodra het mag én er ~1 s niets anders openstaat (cookiebanner, lade, configurator, menu, zoeken, chat) */
    var tik = setInterval(function () {
      if (klaar) { clearInterval(tik); return; }
      if (!gewenst) return;
      if (wkBezet()) { vrij = 0; return; }
      if (++vrij < 2) return;
      if (SS.welkom() !== 'later') { klaar = true; clearInterval(tik); }
    }, 500);
  }

  /* ---------- fase C0: taal/land-paneel in de kop: sluit bij Esc en bij klikken ernaast ---------- */
  function lokalisatie() {
    var d = $('[data-loc-kop]'); if (!d) return;
    document.addEventListener('click', function (e) { if (d.open && !d.contains(e.target)) d.open = false; });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && d.open) { d.open = false; var s = $('summary', d); if (s) s.focus(); } });
  }

  function init() {
    aankondiging();
    if (window.innerWidth < 900) $$('.f-col').forEach(function (d) { d.removeAttribute('open'); });
    zoeken(); nieuwsbrief(); welkomPlannen(); lokalisatie();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
